module.exports = __webpack_public_path__ + "img/sj.160e0186.svg";